import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { AssignPatientLoadingDose } from '../../services/customer.service';
import { FormControl, FormLabel, makeStyles, TextField, Typography, Select, MenuItem } from '@material-ui/core';
import Dialog from '../ui/Dialog';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { getProductBrandList } from '../../services/product.service';

const AssignLoadingDose = ({ data }) => {
    const { patient_id, status, program_id, treatment_received_before, loading_dose } = data;
    const [openModal, setOpenModal] = useState(false);
    const [openConfirmation, setConfirmation] = useState(false);
    const [openConfirmTier, setOpenConfirmTier] = useState(false);
    const [modalTitle, setModalTitle] = useState("Approval / Rejection of Patient Registration");
    const [successMessage, setSuccessMessage] = useState('');
    const [rejectionNotes, setRejectionNotes] = useState(""); 
    
  
    const useStyles = makeStyles(() => ({
        field: {
            marginBottom: 20,
        },
        formControl: {
            width: '250px',
            height: '250px',
            marginTop: '10px',
            marginBottom: '20px',
        }
    }));

    const classes = useStyles();

    const onClick = async (action) => {
        if (window.confirm(`Do you want to ${action} Loading Dosa?`)) {
            if (action === "Assign") {
                try {
                    const res = await AssignPatientLoadingDose({
                        program_id,
                        customer_id: patient_id,
                        payload: { "action": "assign" }
                    });
                    alert("Loading Dose assigned successfully");
                    //alert(res.message);
                    window.location.reload();
                } catch (err) {
                    alert(err.message)
                }
            }
            if (action === "reject") {
               try {
                    const res = await AssignPatientLoadingDose({
                        program_id,
                        customer_id: patient_id,
                        payload: { "action": "reject" }
                    });
                    alert("Loading Dose rejected successfully");
                    //alert(res.message);
                    window.location.reload();
                } catch (err) {
                    alert(err.message)
                }
            }
        }
    };

    if (treatment_received_before !== "no" || loading_dose.toLowerCase() === "yes" || loading_dose.toLowerCase() === "no") {
        return <></>;
    }
    
    return (
        <>
            <Button color="primary" variant="contained" onClick={() => onClick('Assign')} style={{ marginRight: 8 }} >Assign LD</Button>
            <Button variant="contained" onClick={() => onClick('reject')} style={{ marginRight: 8 }}>Reject LD</Button>
        </>
    )
}

export default AssignLoadingDose;
